// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const Styles = css`
  .remember-me-text {
    display: block;
  }
  .already-account {
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    color: ${(props) => props.theme.colorPalette.gray[900]};
  }
  .i-agree-checkbox {
    padding-top: 10px;
  }
  .checkbox-hide-show {
    background: ${(props) => props.theme.colors.WHITE};
  }
  .tooltip-bubble {
    li {
      text-align: left;

      &:before {
        content: '-';
        text-indent: -5px;
        margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
      }
    }
  }
  .Checkbox__error {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    padding-left: 37px;
  }
  #checkbox__error__iAgree {
    margin-top: 0px;
  }
  .checkbox-hide-show label {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
    min-height: 0px;
  }
  .CheckBox__text {
    line-height: 10px;
  }
  .rounded-corner {
    border-radius: 6px;
  }
  .name-container {
    display: flex;
    @media ${(props) => props.theme.mediaQuery.medium} {
      flex-direction: column;
    }
  }

  .last-name {
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-left: 0;
    }
  }
  .TextBox__input {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
  }
  .email-hide {
    display: none;
  }
  .bonus-points-event-banner {
    background-color: #00a7e0;
    border-radius: 6px;
    margin-bottom: 24px;
    padding: 10px;
    width: 110%;
    margin-left: -7%;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 105%;
      margin-left: -5%;
    }
  }
  .bonus-points-event-banner-message {
    color: white;
    display: flex;
    font-family: ${(props) => props.theme.fonts.primary};
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    align-items: center;
    justify-content: center;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
    }

    img {
      padding: 0px 5px;
    }
  }
  .bonus-points-event-banner-account-message {
    color: white;
    display: flex;
    font-family: ${(props) => props.theme.fonts.primary};
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    font-weight: ${(props) => props.theme.fonts.fontWeight.semiBold};
    align-items: center;
    justify-content: center;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
    }
  }
  .details {
    text-decoration: underline;
    margin-left: 6px;
  }
  .Checkbox__error .warning-icon {
    height: 13px;
  }
`;

export default Styles;
